import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { UsuarioPassChangeComponent } from './components/usuario/usuario-pass-change/usuario-pass-change.component';
import { SesionService } from './utils/sesion/sesion.service';
import data from './utils/sesion/routes.json'
import { ProductoService } from './components/producto/producto.service';
import { SucursalService } from './components/sucursal/sucursal.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { ArcElement, BarController, BarElement, CategoryScale, Chart, DoughnutController, LinearScale, LineController, LineElement, PointElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { VersionUpdateComponent } from './utils/version-update/version-update.component';
import { MarkdownService } from 'ngx-markdown';
import { SuscripcionesPagoPendienteComponent } from './components/suscripciones/suscripciones-pago-pendiente/suscripciones-pago-pendiente.component';
import { SuscripcionesInformacionPlanesComponent } from './components/suscripciones/suscripciones-informacion-planes/suscripciones-informacion-planes.component';
import { environment } from 'src/environments/environment';
import { ModalContactoSoporteComponent } from './shared/contacto-soporte/contacto-soporte.component';
import { DateService } from './utils/date/date.service';
import { TestPlanSelectorComponent } from './utils/test-plan-selector/test-plan-selector.component';
import { SuscripcionesService } from './components/suscripciones/suscripciones.service';
import { SentryService } from './utils/sentry/sentry.service';
import { SugerenciaComponent } from './shared/sugerencia/sugerencia.component';
import { EncuestaNpsCreateComponent } from './components/encuesta-nps/encuesta-nps-create/encuesta-nps-create.component';
import { EncuestaNPSService } from './components/encuesta-nps/encuesta-nps.service';
import { AvisoSistemaComponent } from './utils/aviso-sistema/aviso-sistema.component';
import { InfoEmpresaAlertComponent } from './shared/info-empresa-alert/info-empresa-alert.component';
import { VersionCheckService } from './utils/version-check/version-check.service';
import Clarity from '@microsoft/clarity';
import { ClarityService } from './utils/clarity/clarity.service';
import { TrialToPremiumComponent } from './shared/trial-to-premium-alert/trial-to-premium.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  fechaAlertaVencimientoSuscripcionPrueba: string = '';
  fechaAlertaVencimientoSuscripcion: string = '';
  diasHastaVencimiento: number | null = null;
  DIAS_TRAS_VENCIMIENTO_LIMITE = -5;
  version: string = environment.version;

  routes: any[] = [];
  configRutas: { [index: string]: any } = data;

  index: any = {
    "page": 1,
    "sorted_asc": true,
    "sorted": false,
    "sorted_by": null,
    "filtered": false,
    "filters": [],
    "pageSize": 20
  };
  stockCriticos: Array<any> = [];
  habilitarSuscripciones = environment.habilitarSuscripciones;

  alertas: Array<any> = [];

  logo: string = '/assets/system/logo_sidebar.png';

  constructor(
    public sesion: SesionService,
    private router: Router,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    private productoService: ProductoService,
    private ngSelectConfig: NgSelectConfig,
    private sucursalService: SucursalService,
    private mdService: MarkdownService,
    private date: DateService,
    private suscripcionesService: SuscripcionesService,
    private sentryService: SentryService,
    private encuestaNPS: EncuestaNPSService,
    public versionService: VersionCheckService,
    private clarityService: ClarityService,
  ) {
    Chart.register(ChartDataLabels);
    Chart.register(
      DoughnutController,
      ArcElement,
      LinearScale,
      BarController,
      CategoryScale,
      BarElement,
      LineController,
      PointElement,
      LineElement
    );

    this.ngSelectConfig.notFoundText = 'Ningún elemento encontrado.';

    let tema = localStorage.getItem('kuv-dark-theme');
    if (tema) {
      if (tema == 'true') {
        this.cambiarTema();
      }
    }
  }

  asignarRutas(): void {
    this.loading.show();
    this.sesion.getHomeOptions().subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.sesion.routes = res.routes;
        this.sesion.actualizarElementosBuscadorMenu(res.routes);
      },
      error: (err: any) => {
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
        this.sentryService.captureException(err);
      }
    });
  }

  ngOnInit() {
    this.fechaAlertaVencimientoSuscripcionPrueba = this.date.format(this.date.addTime('+3 days'), 'yyyy-mm-dd HH:ii:ss');
    this.fechaAlertaVencimientoSuscripcion = this.date.format(this.date.addTime('+7 days'), 'yyyy-mm-dd HH:ii:ss');

    // Elimina el concepto del menú lateral
    this.isLogged();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mostrarEncuestaNPS();
    }, 1000);
  }

  cambiarTema(): void {
    if (this.sesion.darkTheme) {
      document.documentElement.style.setProperty("--black", "#000");
      document.documentElement.style.setProperty("--white", "#fff");
      document.documentElement.style.setProperty("--white-variable", "#fff");
      document.documentElement.style.setProperty("--hover", "#f7f7f7");
      document.documentElement.style.setProperty("--dark", "#555");
      document.documentElement.style.setProperty("--border", "#d4d9de");
      document.documentElement.style.setProperty("--dark-text", "#333");
      document.documentElement.style.setProperty("--accent", "#aaa");
      document.documentElement.style.setProperty("--accent", "#aaa");
      document.documentElement.style.setProperty("--white-child", "#f0f0f0");
      document.documentElement.style.setProperty("--shadow", "gray");
      document.documentElement.style.setProperty("--modal", "#fff");
      document.documentElement.style.setProperty("--green-tint", "#effcf6");
      document.documentElement.style.setProperty("--red-tint", "#fcefef");
      document.documentElement.style.setProperty("--light", "#F8F9FA");
      document.documentElement.style.setProperty("--invisible-white", "transparent");
      document.documentElement.style.setProperty("--bg-disabled", "#e9ecef");

      this.logo = '/assets/system/logo_sidebar.png';
      this.sesion.darkTheme = false;
      localStorage.setItem('kuv-dark-theme', 'false');
    } else {
      document.documentElement.style.setProperty("--black", "#e0dddd");
      document.documentElement.style.setProperty("--white", "#3b4148");
      document.documentElement.style.setProperty("--white-variable", "#464c53");
      document.documentElement.style.setProperty("--white-child", "#22272b");
      document.documentElement.style.setProperty("--dark-text", "#e0dddd");
      document.documentElement.style.setProperty("--border", "#313131");
      document.documentElement.style.setProperty("--accent", "#555");
      document.documentElement.style.setProperty("--accent2", "#aaa");
      document.documentElement.style.setProperty("--dark", "#dad7d7");
      document.documentElement.style.setProperty("--hover", "#556");
      document.documentElement.style.setProperty("--shadow", "black");
      document.documentElement.style.setProperty("--modal", "#22272b");
      document.documentElement.style.setProperty("--green-tint", "#005500");
      document.documentElement.style.setProperty("--red-tint", "#550000");
      document.documentElement.style.setProperty("--light", "#555");
      document.documentElement.style.setProperty("--invisible-white", "#F8F9FA");
      document.documentElement.style.setProperty("--bg-disabled", "#333334");
      this.logo = '/assets/system/logo_sidebar_white.png';
      this.sesion.darkTheme = true;
      localStorage.setItem('kuv-dark-theme', 'true');
    }
  }

  obtenerDiasHastaVencimiento(): number {
    if (!this.fechaAlertaVencimientoSuscripcionPrueba) return 0;
    if (this.diasHastaVencimiento != null) return this.diasHastaVencimiento ?? 0;
    this.diasHastaVencimiento = this.date.dateDiffFixed(new Date(), new Date(this.sesion.user.vencimiento_suscripcion), 'days');
    return this.diasHastaVencimiento ?? 0;
  }

  loadDataAfterLogin(): void {
    this.asignarRutas();
    this.obtenerDiasHastaVencimiento();
    this.cargarVersionUpdate();
    this.getSucursales();
    this.cargarStockCritico();
    if (environment.habilitarSuscripciones && this.sesion.user.rol_id != 0) this.checkPaymentState();
    this.clarityService.initClarity();
    this.mostrarPlanesAntesVencimientoPeriodoPrueba();

  }

  mostrarPlanesAntesVencimientoPeriodoPrueba(): void {
    if (this.diasHastaVencimiento != null && this.diasHastaVencimiento <= 2 && this.sesion.user.cuenta_prueba) {
      if (!this.sesion.enableSubscriptionUI) return;
      this.loading.show();
      this.suscripcionesService.planActual().subscribe({
        next: (res: any) => {
          this.loading.hide();
          const modalRef = this.modalService.open(SuscripcionesInformacionPlanesComponent, { size: 'xl', scrollable: true, centered: true });
          modalRef.componentInstance.suscripcionPrevia = res.suscripcion;
          modalRef.componentInstance.suscripcionVPPrevia = res.suscripcionVP;
          modalRef.componentInstance.suscripcionDLGPrevia = res.suscripcionDLG;
          modalRef.result.then((result: any) => { }, (reason: any) => { });
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("Error al obtener la información.", "danger");
          this.sentryService.captureException(err.error);
        }
      });
    }
  }

  checkPaymentState(): void {
    this.loading.show();
    this.sesion.getPaymentState().subscribe({
      next: (res: any) => {
        this.loading.hide();
        if (!res.suscripcion_activa) {
          this.sesion.redirectToSuscripcionExpirada = true;
          this.router.navigate(['suscripcion-expirada']);
          /*
           this.loading.show()
          this.sesion.checkPaymentState().subscribe({
            next: (res: any) => {
              this.loading.hide();
              const modalRef = this.modalService.open(SuscripcionesPagoPendienteComponent, { centered: true, backdrop: 'static' });
              modalRef.result.then((result: any) => {
                if (result.cerrarSesion) {
                  this.logout();
                  return;
                } else {
                  this.checkPaymentState();
                }
              }, (reason: any) => {
                this.checkPaymentState();
              });
            }, error: (err: any) => {
              this.loading.hide();
              if (err.response) this.alerts.addAlert(err.response, 'danger');
            }
          });
          */
        }
      },
      error: (err: any) => {
        this.loading.hide();
        console.error(err);
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }

  mostrarVersion(): void {
    this.sesion.getLatestVersion().subscribe({
      next: (version: any) => {
        if (!version) return;
        localStorage.setItem('latest-version', version);
        this.sesion.getLatestVersionMd().subscribe({
          next: (resMD: any) => {
            let md = this.mdService.compile(resMD);
            const modalRef = this.modalService.open(VersionUpdateComponent, { size: 'xl', scrollable: true, windowClass: 'modal-version-update' });
            modalRef.componentInstance.md = md;
            modalRef.componentInstance.version = version;
            modalRef.result.then((result: any) => { }, (reason: any) => { });
          },
          error: (err: any) => { }
        });
      },
      error: (err: any) => { }
    });
  }

  cargarVersionUpdate(): void {
    let reload = false;
    this.sesion.getLatestVersion().subscribe({
      next: (version: any) => {
        if (!version) return;
        if (localStorage.getItem('latest-version') != version) {
          localStorage.setItem('latest-version', version);
          this.sesion.getLatestVersionMd().subscribe({
            next: (resMD: any) => {
              let md = this.mdService.compile(resMD);
              const modalRef = this.modalService.open(VersionUpdateComponent, { size: 'xl', scrollable: true, windowClass: 'modal-version-update' });
              modalRef.componentInstance.md = md;
              modalRef.componentInstance.version = version;
              modalRef.result.then((result: any) => { reload = true; }, (reason: any) => { reload = true; });
            },
            error: (err: any) => { }
          });
        }
      },
      error: (err: any) => {
        this.cargarAviso(reload);
      },
      complete: () => {
        if (this.sesion.user.cuenta_prueba) {
          this.cargarAvisoTrial(reload);
        } else {
          this.cargarAviso(reload);
        }
      }
    });
  }

  cargarAviso(reload: boolean = false): void {
    this.sesion.getAvisoSistema().subscribe({
      next: (version: any) => {
        if (!version) return;
        if (localStorage.getItem('aviso-sistema') != version) {
          this.sesion.getAvisoSistemaMd().subscribe({
            next: (resMD: any) => {
              const modalRef = this.modalService.open(AvisoSistemaComponent, { size: 'md', scrollable: true, windowClass: 'modal-version-update' });
              modalRef.componentInstance.md = resMD;
              modalRef.componentInstance.version = version;
              modalRef.result.then((result: any) => {
                localStorage.setItem('aviso-sistema', version);
              }, (reason: any) => { });
            },
            error: (err: any) => { }
          });
        }
      },
      error: (err: any) => {
        if (reload) location.reload();
      },
      complete: () => {
        if (reload) location.reload();
      }
    });
  }

  cargarAvisoTrial(reload: boolean = false): void {
    this.sesion.getAvisoSistemaTrial().subscribe({
      next: (resp: any) => {
        switch (resp.dia) {
          case 4:
            const modalRef = this.modalService.open(TrialToPremiumComponent, { size: 'lg', scrollable: true });
            modalRef.result.then((result: any) => { }, (reason: any) => { });
            break;
          default:
            break;
        }
      },
      error: (err: any) => {
        if (reload) location.reload();
      },
      complete: () => {
        if (reload) location.reload();
      }
    });
  }

  changePass(): void {
    let modalRef = this.modalService.open(UsuarioPassChangeComponent, { centered: true });
    modalRef.result.then((result) => { }, (reason) => { });
  }

  verPerfil(): void {
    const urlOpciones = '/empresa/settings';
    const urlDestino = '/empresa/settings/profile';
    let reload = false;
    if (this.router.url == urlDestino) return;
    if (this.router.url.includes(urlOpciones)) reload = true;
    if (reload) {
      this.router.navigate(['loading']).finally(() => {
        this.router.navigate([urlDestino]);
      });
    } else {
      this.router.navigate([urlDestino]);
    }
  }

  goToSettings(): void {
    const urlOpciones = '/empresa/settings';
    const urlDestino = '/empresa/settings/general';
    const urlDestino2 = '/empresa/settings';
    let reload = false;
    if (this.router.url == urlDestino || this.router.url == urlDestino2) return;
    if (this.router.url.includes(urlOpciones)) reload = true;
    if (reload) {
      this.router.navigate(['loading']).finally(() => {
        this.router.navigate([urlDestino]);
      });
    } else {
      this.router.navigate([urlDestino]);
    }
  }

  verSuscripcion(): void {
    const urlOpciones = '/empresa/settings';
    const urlDestino = '/empresa/settings/subscription';
    let reload = false;
    if (this.router.url == urlDestino) return;
    if (this.router.url.includes(urlOpciones)) reload = true;
    if (reload) {
      this.router.navigate(['loading']).finally(() => {
        this.router.navigate([urlDestino]);
      });
    } else {
      this.router.navigate([urlDestino]);
    }
  }

  logout(): void {
    this.loading.show();
    this.sesion.clearSesion();
    this.loading.hide();
    this.router.navigate(['login']);
    this.sentryService.setUser(null, null);
  }

  searchFn(term: string, item: any): any {
    const removeAccents = (str: string) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre].join(' ')).toLowerCase());
    terms.forEach(t => {
      result = result && p.includes(t);
    });
    return result;
  }

  isLogged(): void {
    const excludedPaths = [
      '/privacidad',
      '/terminos',
      '/soporte',
      '/recuperar-password',
      '/restablecer',
      '/test-qr',
      '/suscripcion-tos',
      '/agendar',
      '/revision/mi-revision',
      '/revision/certificado'
      
    ];
    if (excludedPaths.some(path => window.location.pathname === path || window.location.pathname.includes(path))) return;

    if (this.sesion.token) {
      this.loading.show();
      this.sesion.isLogged().subscribe({
        next: (res) => {
          this.loading.hide();
          this.sentryService.setUser(this.sesion.user.email, this.sesion.user.empresa_id);
          this.loadDataAfterLogin();
          if (this.sesion.user.rol_id != 0 && this.sesion.user.rol_id != 1) return;
          const empresa = res.empresa;
          if (!empresa) return;
          if (!empresa?.nombre || !empresa?.rut || !empresa?.razon_social || !empresa?.email) {
            const modalRef = this.modalService.open(InfoEmpresaAlertComponent, { windowClass: 'clear-modal', size: 's', scrollable: true, centered: true, backdrop: 'static' });
            modalRef.componentInstance.element = empresa;
            modalRef.result.then((result: any) => { }, (reason: any) => { });
          }
          if (!environment.production) return;
          this.versionService.checkVersion();
          this.versionService.initVersionCheckInBG();
        },
        error: (err) => {
          console.error(err);
          if (err.error && err.error.invalid) {
            this.sesion.clearSesion();
            this.router.navigate(['login']);
            this.sentryService.setUser(null, null);
          } else {
            this.sentryService.setUser(this.sesion.user.email, this.sesion.user.empresa_id);
            this.router.navigate(['home']);
          }
          this.loading.hide();
          this.alerts.addAlert("Sesión expirada.", "danger");
        }
      })
    } else {
      this.router.navigate(['login']);
      this.sentryService.setUser(null, null);
    }
  }

  get hideTopInfoBar(): boolean {
    if (this.router.url.includes('/suscripcion-tos')) return true;
    return false;
  }

  get showSidebarAndHeader(): boolean {
    const excludedUrls = [
      '/login',
      '/terminos',
      '/soporte',
      '/recuperar-password',
      '/restablecer',
      '/test-qr',
      '/suscripcion-tos',
      '/agendar',
      '/privacidad',
      '/revision/mi-revision',
      '/revision/enlace-certificado'
    ];
    return !excludedUrls.some(url => this.router.url === url || this.router.url.includes(url));
  }

  verStockCritico(): void {
    this.router.navigate(['producto/stock-critico']);
  }

  getSucursales(): void {
    if (!this.sesion.token) return;
    this.sucursalService.misSucursales().subscribe({
      next: (res) => {
        this.sesion.sucursales = res.sucursales;
        if (this.sesion.sucursales.length > 0) {
          let localSucursalID = this.sesion.loadLocalSucursal();
          if (localSucursalID) {
            this.sesion.sucursalIndex = this.sesion.sucursales.findIndex(s => s.id == localSucursalID);
            if (localSucursalID != -1) {
              this.sesion.setSucursal(this.sesion.sucursales[this.sesion.sucursalIndex]);
              this.sesion.saveSucursal(this.sesion.sucursal.id);
            } else {
              this.sesion.setSucursal(this.sesion.sucursales[0]);
              this.sesion.saveSucursal(this.sesion.sucursal.id);
            }
            return;
          }
          if (this.sesion.sucursal?.id != this.sesion.sucursales[0].id) {
            localStorage.setItem('sucursal', JSON.stringify(this.sesion.sucursales[0]));
            this.sesion.setSucursal(this.sesion.sucursales[0]);
            let sucursal = this.sesion.sucursal;
            this.sesion.sucursalIndex = this.sesion.sucursales.findIndex(s => s.id == sucursal.id);
            this.sesion.saveSucursal(this.sesion.sucursal.id);
          } else {
            let sucursal = this.sesion.sucursal;
            this.sesion.sucursalIndex = this.sesion.sucursales.findIndex(s => s.id == sucursal.id);
          }
        }
      },
      error: (err) => {
        console.error(err);
        this.sentryService.captureException(err);
      }
    });
  }

  changeScope(ev: any): void {
    if (!ev.target.value) return;
    let s = this.sesion.sucursales[ev.target.value];
    localStorage.setItem('sucursal', JSON.stringify(s));
    this.sesion.setSucursal(s);
    if (this.sesion.sucursal) {
      this.sesion.saveSucursal(this.sesion.sucursal.id);
    }
    let aux = this.router.url;
    this.router.navigate(['loading']);
    setTimeout(() => {
      this.router.navigate([aux]);
    }, 0);
  }

  enviarSugerencia(): void {
    const modalRef = this.modalService.open(SugerenciaComponent, { size: 'lg', scrollable: true, centered: true });
    modalRef.result.then((result: any) => { }, (reason: any) => { });
  }

  cargarStockCritico(): void {
    this.loading.show();
    this.productoService.stockCritico(this.index).subscribe({
      next: (res: any) => {
        this.loading.hide();
        this.stockCriticos = res.elements;
      },
      error: (err: any) => {
        console.error(err);
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
        this.sentryService.captureException(err.error);
      }
    });
  }

  crearOT(): void {
    this.router.navigate(['/revisiones/create']);
  }

  soporteLubriKuv(): void {
    const modalRef = this.modalService.open(ModalContactoSoporteComponent, { windowClass: 'clear-modal', size: 's', scrollable: true, centered: true });
    modalRef.componentInstance.soloDemo = this.sesion.user.cuenta_prueba;
    modalRef.componentInstance.showTutorialButton = true;
    modalRef.result.then((result: any) => {
    }, (reason: any) => { });
  }

  async realizarPagoPremium() {
    if (!this.sesion.enableSubscriptionUI) return;
    this.loading.show();
    this.suscripcionesService.planActual().subscribe({
      next: (res: any) => {
        this.loading.hide();
        const modalRef = this.modalService.open(SuscripcionesInformacionPlanesComponent, { size: 'xl', scrollable: true, centered: true });
        modalRef.componentInstance.suscripcionPrevia = res.suscripcion;
        modalRef.componentInstance.suscripcionVPPrevia = res.suscripcionVP;
        modalRef.componentInstance.suscripcionDLGPrevia = res.suscripcionDLG;
        modalRef.result.then((result: any) => { }, (reason: any) => { });
      },
      error: (err: any) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("Error al obtener la información.", "danger");
        this.sentryService.captureException(err.error);
      }
    });
  }

  cambiarPrueba(): void {
    const modalRef = this.modalService.open(TestPlanSelectorComponent, { size: 'lg', scrollable: true, centered: true });
    modalRef.result.then((result: any) => { }, (reason: any) => { });
  }

  getPlan(): string {
    switch (this.sesion.user?.suscripcion?.plan_id) {
      case 1:
        return 'FILTRO X';
      case 2:
        return 'FILTRO X';
      case 3:
        return 'ACELERA +';
      case 4:
        return 'ACELERA +';
      case 5:
        return 'TURBO';
      case 6:
        return 'TURBO';
      default:
        return '';
    }
  }

  mostrarEncuestaNPS(): void {
    if (this.encuestaNPS.debeMostrarEncuestaNPS(this.sesion.user) && this.sesion.user.empresa_id != 737) {
      this.modalService.open(EncuestaNpsCreateComponent, { size: 'xl', scrollable: true, backdrop: 'static', keyboard: false });
    }
  }

  reloadPage(): void {
    window.location.reload();
  }
}
